/* HushGlow — all interactivity. Vanilla, deferred, no dependencies.
   Each module is guarded: if its section isn't on the page, it exits. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function currentProduct() {
    if (document.body.classList.contains('hg-tpl-hushglow')) return 'hush_ember';
    if (document.body.classList.contains('hg-tpl-hush-halo')) return 'hush_halo';
    return '';
  }

  function sourcePage() {
    if (document.body.classList.contains('hg-tpl-hush-ritual')) return 'hush_ritual';
    if (document.body.classList.contains('hg-tpl-science')) return 'science';
    if (currentProduct()) return currentProduct() + '_pdp';
    if (window.location.pathname === '/') return 'home';
    return window.location.pathname;
  }

  /* Use Shopify's existing analytics bridge only. The DOM event makes the
     same payload observable in QA and by first-party listeners. Analytics is
     deliberately non-blocking, including when a link navigates immediately. */
  function publishAnalytics(name, properties) {
    var detail = {
      name: name,
      properties: Object.assign({
        source_page: sourcePage(),
        page_path: window.location.pathname
      }, properties || {})
    };

    document.dispatchEvent(new CustomEvent('hush:analytics', { detail: detail }));

    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    try {
      var result = window.Shopify.analytics.publish(name, detail.properties);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (error) {
      // Analytics must never interrupt navigation or purchasing.
    }
  }

  /* --- 1. Announcement bar -------------------------------------------
     Cross-fades between messages. Pauses on hover/focus. With reduced
     motion, messages still rotate but without the fade.                */
  function announcementBar() {
    document.querySelectorAll('[data-hg-rotator]').forEach(function (root) {
      var items = root.querySelectorAll('[data-hg-rotator-item]');
      if (items.length < 2) return;

      var delay = parseInt(root.dataset.hgRotatorDelay, 10) || 4000;
      var i = 0;
      var timer = null;

      function show(n) {
        items.forEach(function (el, idx) {
          var on = idx === n;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      }

      function next() { i = (i + 1) % items.length; show(i); }
      function start() { if (!timer) timer = setInterval(next, delay); }
      function stop() { clearInterval(timer); timer = null; }

      show(0);
      start();

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : start();
      });
    });
  }

  /* --- 2. Header ------------------------------------------------------
     Adds .is-scrolled past a threshold (drives the blur/background), and
     toggles the mobile drawer with focus trapping and Esc to close.     */
  function header() {
    var el = document.querySelector('[data-hg-header]');
    if (!el) return;

    /* ---- scrolled state ------------------------------------------------ */
    var threshold = 8;
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        el.classList.toggle('is-scrolled', window.scrollY > threshold);
        ticking = false;
      });
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ---- drawer -------------------------------------------------------- */
    var toggle = el.querySelector('[data-hg-nav-toggle]');
    var drawer = document.querySelector('[data-hg-nav-drawer]');
    if (!toggle || !drawer) return;

    var panel = drawer.querySelector('[data-hg-drawer-panel]');
    var open = false;
    var scrollY = 0;
    var closeTimer = null;

    /* Body scroll lock. position:fixed is the only approach iOS Safari
       actually honours; overflow:hidden alone lets the page behind keep
       scrolling under the drawer. The offset is restored on close so the
       reader lands exactly where they left. */
    function lockScroll() {
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      /* 'instant' so restoring position is never animated by
         html { scroll-behavior: smooth }. */
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    }

    function focusables() {
      return drawer.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }

    function setOpen(next) {
      if (next === open) return;
      open = next;
      clearTimeout(closeTimer);

      el.classList.toggle('is-nav-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (open) {
        lockScroll();
        drawer.hidden = false;
        /* The transition needs a resolved start value between `hidden` coming
           off and `.is-open` going on. Reading offsetWidth forces that style
           flush synchronously — a rAF pair also works but silently does not in
           a background or throttled tab, which would leave the drawer open at
           opacity 0: visible to the keyboard, invisible on screen. */
        void drawer.offsetWidth;
        drawer.classList.add('is-open');
        var first = drawer.querySelector('[data-hg-nav-close]') || focusables()[0];
        if (first) first.focus();
      } else {
        drawer.classList.remove('is-open');
        unlockScroll();
        /* Wait out the exit transition before hiding, so closing animates.
           A timer rather than transitionend: if the transition is cancelled or
           never fires (reduced motion, background tab) the drawer would stay
           in the DOM and swallow taps forever. */
        closeTimer = setTimeout(function () { drawer.hidden = true; }, 320);
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function () { setOpen(!open); });

    drawer.querySelectorAll('[data-hg-nav-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(false); });
    });

    /* Tap outside the panel. */
    drawer.addEventListener('click', function (e) {
      if (panel && !panel.contains(e.target)) setOpen(false);
    });

    /* Following a link inside the drawer must release the lock — including
       same-page anchors, which fire no navigation at all. */
    drawer.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (link) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) setOpen(false);
    });

    /* Focus trap. */
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !open) return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Resizing up to desktop hides the drawer in CSS; without this the scroll
       lock would survive with no visible way to release it. */
    var desktop = window.matchMedia('(min-width: 750px)');
    var onBreak = function (e) { if (e.matches && open) setOpen(false); };
    if (desktop.addEventListener) desktop.addEventListener('change', onBreak);
    else desktop.addListener(onBreak);

    /* Restoring a bfcache page can resurrect the locked state. */
    window.addEventListener('pageshow', function (e) { if (e.persisted && open) setOpen(false); });

    drawer.hidden = true;
  }

  /* --- 3. Reviews carousel -------------------------------------------
     Buttons nudge scrollLeft by one card. Scrolling itself is native
     scroll-snap, so the carousel works fully without this.              */
  function carousel() {
    document.querySelectorAll('[data-hg-carousel]').forEach(function (track) {
      var root = track.closest('section') || document;
      var prev = root.querySelector('[data-hg-carousel-prev]');
      var next = root.querySelector('[data-hg-carousel-next]');
      if (!prev || !next) return;

      function step() {
        var card = track.querySelector('li');
        return card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      }
      function go(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        prev.style.opacity = prev.disabled ? 0.4 : 1;
        next.style.opacity = next.disabled ? 0.4 : 1;
      }
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* --- 3b. Deferred images --------------------------------------------
     loading="lazy" is not a bandwidth control. Chrome's lazy viewport
     threshold runs to a few thousand pixels on a slow connection, so
     below-the-fold images still start downloading during the initial load and
     share the pipe with the LCP image. Measured on the PDP: the LCP image is
     18.7 KB but took 3.4 s to transfer while ~960 KB of other requests were in
     flight alongside it.

     Anything marked data-hg-lazysrc keeps its URLs in data-src/data-srcset
     until it is within 400px of the viewport, at which point they move onto
     the real attributes and the browser fetches normally. Without JS the
     images never load, so this is only for decorative or below-the-fold
     media — never for anything the page's meaning depends on. */
  function deferredImages() {
    var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-hg-lazysrc]'));
    if (!imgs.length) return;

    function load(img) {
      /* <source> first: inside a <picture> it decides the candidate, so
         promoting the <img> alone would fetch the fallback and then fetch
         again once the source appeared. */
      var pic = img.parentElement;
      if (pic && pic.tagName === 'PICTURE') {
        pic.querySelectorAll('source[data-srcset]').forEach(function (src) {
          src.srcset = src.dataset.srcset;
          src.removeAttribute('data-srcset');
        });
      }
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
      if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
      img.removeAttribute('data-hg-lazysrc');
    }

    if (!('IntersectionObserver' in window)) { imgs.forEach(load); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        load(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '400px 0px' });
    imgs.forEach(function (img) { io.observe(img); });
  }

  /* --- 4. UGC grid ----------------------------------------------------
     Mobile is a snap carousel: only the current video plays and the dots
     track the nearest card. Desktop keeps every grid video playing. Media is
     activated only as the section approaches the viewport, avoiding a large
     off-screen video download during the initial page load. */
  function ugc() {
    var mobile = window.matchMedia('(max-width: 749px)');

    document.querySelectorAll('[data-hg-ugc]').forEach(function (grid) {
      var cells = Array.prototype.slice.call(grid.querySelectorAll('.hg-ugc__cell'));
      /* The carousel's running order is whatever CSS `order` actually painted,
         not DOM order — read it back from layout rather than hard-coding a
         remap for one particular card count. Anything not laid out in a row
         (desktop, or before first paint) falls back to DOM order. */
      var mobileCells = cells.slice();
      function orderCells() {
        mobileCells = cells.slice().sort(function (a, b) {
          return a.offsetLeft - b.offsetLeft;
        });
      }
      orderCells();
      var videos = Array.prototype.slice.call(grid.querySelectorAll('video'));
      var dotsWrap = grid.parentElement && grid.parentElement.querySelector('[data-hg-ugc-dots]');
      var dots = dotsWrap
        ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-hg-ugc-dot]'))
        : [];
      var active = 0;
      var ticking = false;
      /* Raised while we drive the carousel ourselves (finger drag, then the
         smooth scroll to the target). The scroll listener's nearest-cell guess
         is meaningless mid-flight — on Android it made the dots flick through
         one or two neighbours before landing — so slideTo owns the dot state
         for the whole gesture. */
      var driving = false;
      var isNearViewport = false;

      videos.forEach(function (video) {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;

        // Our poster overlay (see hg-ugc-grid.liquid) covers the black gap
        // between .play() being called and a real frame actually painting.
        // 'playing' only fires once a frame is on screen, so this can't
        // fade early and expose the gap it's meant to hide.
        var media = video.closest('[data-hg-ugc-media]');
        if (media) {
          video.addEventListener('playing', function () {
            media.classList.add('is-playing');
          });
        }
      });

      // Only the active slide's video plays, so the ones either side sit at
      // preload="none" until now — the first swipe to one had to fetch its
      // data from a standing start, freezing for a beat before playback.
      // Bumping a neighbor to preload="auto" as soon as it's one swipe away
      // gives it a head start buffering, so it's usually ready by the time
      // the user actually arrives.
      function warm(video) {
        if (!video || video.dataset.hgWarmed) return;
        video.dataset.hgWarmed = '1';
        video.preload = 'auto';
        video.load();
      }

      function setActive(index) {
        active = Math.max(0, Math.min(index, mobileCells.length - 1));
        dots.forEach(function (dot, dotIndex) {
          var current = dotIndex === active;
          dot.classList.toggle('is-active', current);
          if (current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        videos.forEach(function (video) {
          var cellIndex = mobileCells.indexOf(video.closest('.hg-ugc__cell'));
          if (!reduceMotion && isNearViewport && (!mobile.matches || cellIndex === active)) video.play().catch(function () {});
          else video.pause();
        });

        if (isNearViewport && mobile.matches) {
          var prevCell = mobileCells[active - 1];
          var nextCell = mobileCells[active + 1];
          if (prevCell) warm(prevCell.querySelector('video'));
          if (nextCell) warm(nextCell.querySelector('video'));
        }
      }

      function sync() {
        if (driving || !mobile.matches || !mobileCells.length) return;
        var gridLeft = grid.getBoundingClientRect().left;
        var nearest = 0;
        var distance = Infinity;
        mobileCells.forEach(function (cell, index) {
          var nextDistance = Math.abs(cell.getBoundingClientRect().left - gridLeft);
          if (nextDistance < distance) {
            distance = nextDistance;
            nearest = index;
          }
        });
        setActive(nearest);
      }

      grid.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          sync();
          ticking = false;
        });
      }, { passive: true });

      /* One swipe = one slide. Native scroll-snap only decides where a fling
         lands *after* the momentum has run, so on Android a hard flick sails
         past two or three videos before it settles. We take the gesture over:
         note where the swipe started, and on release kill the momentum and
         scroll to exactly one neighbour in the swipe's direction. Slow drags
         under the threshold snap back to where they started. */
      var SWIPE_MIN = 24;
      var AXIS_SLOP = 8;
      var swipeStartX = 0;
      var swipeStartY = 0;
      var swipeStartScroll = 0;
      var swipeIndex = 0;
      var swiping = false;
      var axis = '';
      var settleTimer = null;

      function slideTo(index) {
        var cell = mobileCells[index];
        if (!cell) return;
        /* Snapping goes off for the duration — it would fight the programmatic
           scroll — and comes back once we've settled. */
        grid.style.scrollSnapType = 'none';

        grid.scrollTo({
          left: cell.offsetLeft - mobileCells[0].offsetLeft,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
        setActive(index);

        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          grid.style.scrollSnapType = '';
          driving = false;
          settleTimer = null;
        }, 500);
      }

      grid.addEventListener('touchstart', function (e) {
        if (!mobile.matches || e.touches.length !== 1) return;
        swiping = true;
        driving = true;
        axis = '';
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
        swipeStartScroll = grid.scrollLeft;
        swipeIndex = active;
        if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
        grid.style.scrollSnapType = 'none';
      }, { passive: true });

      /* The track carries touch-action: pan-y, so the browser never scrolls it
         horizontally and never generates a fling — on Chrome for Android that
         fling lives on the compositor thread and sails past two or three cards
         no matter what we do on release. Instead we move scrollLeft with the
         finger ourselves; when the finger lifts there is no momentum left, so
         the one-slide decision below always holds. Vertical swipes are handed
         straight back to the page. */
      grid.addEventListener('touchmove', function (e) {
        if (!swiping || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - swipeStartX;
        var dy = e.touches[0].clientY - swipeStartY;
        if (!axis) {
          if (Math.abs(dx) < AXIS_SLOP && Math.abs(dy) < AXIS_SLOP) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'y') {
            swiping = false;
            driving = false;
            grid.style.scrollSnapType = '';
            return;
          }
        }
        grid.scrollLeft = swipeStartScroll - dx;
      }, { passive: true });

      function endSwipe(e) {
        if (!swiping) return;
        swiping = false;
        var touch = e.changedTouches && e.changedTouches[0];
        var dx = touch ? swipeStartX - touch.clientX : grid.scrollLeft - swipeStartScroll;
        var step = Math.abs(dx) < SWIPE_MIN ? 0 : (dx > 0 ? 1 : -1);
        slideTo(Math.max(0, Math.min(swipeIndex + step, mobileCells.length - 1)));
      }
      grid.addEventListener('touchend', endSwipe, { passive: true });
      grid.addEventListener('touchcancel', endSwipe, { passive: true });

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          mobileCells[index].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
          setActive(index);
        });
      });

      function onBreakpoint() {
        orderCells();
        if (mobile.matches) sync();
        else setActive(active);
      }
      if (mobile.addEventListener) mobile.addEventListener('change', onBreakpoint);
      else mobile.addListener(onBreakpoint);

      orderCells();
      setActive(0);

      // Poster overlays carry data-src/data-srcset rather than src/srcset so
      // that ~314 KB of below-the-fold imagery cannot compete with the LCP
      // image for bandwidth on the initial load. See hg-ugc-grid.liquid.
      var postersPrimed = false;
      function primePosters() {
        if (postersPrimed) return;
        postersPrimed = true;
        grid.querySelectorAll('[data-hg-ugc-poster]').forEach(function (img) {
          if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
          if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
        });
      }

      if ('IntersectionObserver' in window) {
        var mediaObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) primePosters();
            isNearViewport = entry.isIntersecting;
            setActive(active);
          });
        }, { rootMargin: '300px 0px', threshold: 0 });
        mediaObserver.observe(grid);
      } else {
        primePosters();
        isNearViewport = true;
        setActive(active);
      }
    });
  }

  /* --- 5. Product gallery: swipe carousel + thumbnails ----------------
     (Hardi, 03-11-2026). The images sit in one scroll-snap row in
     hg-bundle-selector.liquid, so swiping is native scrolling — the next
     image follows the finger. This only keeps the thumbnails in sync and
     lets a thumbnail tap scroll the row. */
  function gallery() {
    var track = document.querySelector('[data-hg-track]');
    var thumbs = document.querySelectorAll('[data-hg-thumb]');
    if (!track || !thumbs.length) return;

    thumbs = Array.prototype.slice.call(thumbs);
    var strip = thumbs[0].closest('.hg-buy__thumbs');
    var index = 0;

    function mark(i) {
      if (i < 0 || i > thumbs.length - 1) return;
      index = i;
      if (navs) navs.forEach(function (nav) {
        var t = i + parseInt(nav.dataset.hgGalleryNav, 10);
        nav.hidden = t < 0 || t > thumbs.length - 1;
      });
      thumbs.forEach(function (t, n) {
        if (n === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      /* Keep the active thumb visible in the strip. Scrolls the strip only,
         never the page or the image row. */
      if (!strip) return;
      var li = thumbs[i].parentElement;
      var left = li.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
      if (left < strip.scrollLeft || left + li.offsetWidth > strip.scrollLeft + strip.clientWidth) {
        strip.scrollTo({ left: left - 8, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    /* While a thumbnail tap is sliding the row, the row passes the images in
       between — ignore those so their thumbs don't flash. Released when the
       row arrives, when the finger takes over, or after 1s as a fallback. */
    var jumping = null, jumpTimer;
    function endJump() { jumping = null; clearTimeout(jumpTimer); }
    track.addEventListener('touchstart', endJump, { passive: true });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        if (jumping !== null) {
          if (Math.abs(track.scrollLeft - jumping * w) < 2) endJump();
          return;
        }
        var i = Math.round(track.scrollLeft / w);
        if (i !== index) mark(i);
      });
    }, { passive: true });

    function go(i) {
      if (i < 0 || i > thumbs.length - 1) return;
      if (i === index && jumping === null) return;
      jumping = i;
      clearTimeout(jumpTimer);
      jumpTimer = setTimeout(endJump, 1000);
      mark(i);
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { go(i); });
    });

    /* Desktop click zones over the image's left/right third. CSS shows them
       only with a mouse, so on phones they don't exist and swipe is untouched. */
    var navs = Array.prototype.slice.call(document.querySelectorAll('[data-hg-gallery-nav]'));
    navs.forEach(function (nav) {
      nav.addEventListener('click', function () {
        go(index + parseInt(nav.dataset.hgGalleryNav, 10));
      });
    });

    mark(0);
  }

  /* --- 6. Product / Ritual selector + sticky bar ----------------------
     Each choice supplies its real Shopify variant ID. The selected radio is
     the single source for the hidden product ID, quantity and CTA label. */
  function bundles() {
    var form = document.getElementById('hg-buy-form');
    if (!form) return;

    var qtyInput = form.querySelector('[data-hg-qty]');
    var tiers = form.querySelectorAll('[data-hg-tier]');
    var submit = form.querySelector('[type="submit"]');
    var bar = document.querySelector('[data-hg-sticky]');
    var barLabel = document.querySelector('[data-hg-sticky-label]');
    var barPrice = document.querySelector('[data-hg-sticky-price]');
    var barAdd = document.querySelector('[data-hg-sticky-add]');
    var statusMessage = form.querySelector('[data-hg-bundle-status]');
    if (!tiers.length || !qtyInput) return;

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
        }).format(cents / 100);
      } catch (e) {
        return '€' + (cents / 100).toFixed(2);
      }
    }

    /* v2 — Low-stock badge swaps with the selected tier: naming Ember specifically
       whenever the Ritual is chosen (Ember is the scarce part of both offers),
       and — in "ritual only" mode, used on the Halo PDP — staying hidden until
       the shopper actually switches to the Ritual. */
    function syncStockBadge(checked) {
      var badge = form.querySelector('[data-hg-stock]');
      if (!badge) return;
      var isRitual = checked.dataset.ctaLabel === 'Start My Hush Ritual';
      var ritualOnly = badge.dataset.ritualOnly === 'true';
      var textEl = badge.querySelector('[data-hg-stock-text]');
      badge.hidden = ritualOnly ? !isRitual : false;
      if (textEl) {
        textEl.textContent = isRitual ? badge.dataset.ritualText : badge.dataset.singleText;
      }
    }

    function sync(announce) {
      var checked = form.querySelector('[data-hg-tier]:checked');
      if (!checked) return;
      qtyInput.value = checked.value;
      var productId = form.querySelector('[name="id"]');
      if (productId && checked.dataset.variantId) productId.value = checked.dataset.variantId;
      var ctaLabel = checked.dataset.ctaLabel || 'Add to cart';
      if (submit) submit.textContent = ctaLabel;
      if (barAdd) barAdd.textContent = ctaLabel;
      if (barLabel) barLabel.textContent = checked.dataset.label || '';
      if (barPrice) barPrice.textContent = money(parseInt(checked.dataset.price, 10) || 0);
      syncStockBadge(checked);
      if (announce && statusMessage) {
        statusMessage.textContent = (checked.dataset.label || 'Purchase option') + ' selected. ' + ctaLabel + '.';
      }
    }

    var BUNDLE_CHOICE_KEY = 'hg-bundle-choice';

    function tierChoiceValue(t) {
      /* An explicit data-choice wins. The two-pack tier submits quantity 1 (it
         is its own product), so without this it would collide with the single
         lamp's 'qty:1' key and the two could restore each other's selection. */
      if (t.dataset.choice) return t.dataset.choice;
      var isRitual = t.dataset.ctaLabel === 'Start My Hush Ritual';
      return isRitual ? 'ritual' : 'qty:' + t.value;
    }

    function storeBundleChoice(value) {
      try { window.localStorage.setItem(BUNDLE_CHOICE_KEY, value); } catch (e) {}
    }

    /* Carry the shopper's last purchase-option choice (single lamp vs. The
       Hush Ritual) across PDPs, e.g. when they follow the "Hush Halo" /
       "Hush Ember" link inside the bundle card to the other product. */
    (function applyStoredBundleChoice() {
      var stored;
      try { stored = window.localStorage.getItem(BUNDLE_CHOICE_KEY); } catch (e) { stored = null; }

      var match = null;
      if (stored) {
        tiers.forEach(function (t) {
          if (tierChoiceValue(t) === stored) match = t;
        });
      }

      /* No remembered choice yet — keep whichever tier the markup pre-checked
         (single lamp since 24-09-2026; see ritual_preselect in
         hg-bundle-selector.liquid). Previously this forced the Ritual here too,
         which overrode the markup a moment after load. */
      if (!match) {
        tiers.forEach(function (t) {
          if (t.checked) match = t;
        });
      }

      if (!match) return;
      tiers.forEach(function (t) { t.checked = (t === match); });
    })();

    tiers.forEach(function (t) {
      t.addEventListener('change', function () {
        sync(true);
        storeBundleChoice(tierChoiceValue(t));
        var isRitual = t.dataset.ctaLabel === 'Start My Hush Ritual';
        publishAnalytics(isRitual ? 'bundle_selected' : 'single_product_selected', {
          current_product: currentProduct(),
          selected_offer: isRitual ? 'the_hush_ritual' : currentProduct(),
          bundle_name: isRitual ? 'The Hush Ritual' : t.dataset.label,
          section_name: 'purchase'
        });
      });
    });
    sync(false);

    if (barAdd) {
      barAdd.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          /* form.submit() does NOT fire a submit event, so the legacy path
             would silently bypass every submit listener — including the
             pre-checkout upgrade offer. Dispatching first preserves the
             chance to intercept, and the fallback only runs if nobody did. */
          var proceed = form.dispatchEvent(
            new Event('submit', { bubbles: true, cancelable: true })
          );
          if (proceed) form.submit();
        }
      });
    }

    /* Reveal only after the real button has passed ABOVE the viewport. Merely
       being non-intersecting is not enough: before the shopper reaches the buy
       box the button is also non-intersecting, but it is still below them. */
    if (bar && submit && 'IntersectionObserver' in window) {
      bar.hidden = false;

      /* The bar overlays the bottom of the page rather than pushing it, so
         once it's visible the last bit of content (footer company info) can
         end up permanently hidden behind it. Padding the body by the bar's
         own height while it's visible gives the shopper that extra bit of
         scroll room to clear it. */
      function syncStickyPadding() {
        if (bar.classList.contains('is-visible')) {
          document.body.style.paddingBottom = bar.getBoundingClientRect().height + 'px';
        } else {
          document.body.style.paddingBottom = '';
        }
      }

      function syncSticky() {
        var rect = submit.getBoundingClientRect();
        bar.classList.toggle('is-visible', rect.bottom <= 0);
        syncStickyPadding();
      }
      var io = new IntersectionObserver(syncSticky);
      io.observe(submit);
      var pageWrapper = document.querySelector('.page-wrapper');
      window.addEventListener('scroll', syncSticky, { passive: true });
      if (pageWrapper) {
        pageWrapper.addEventListener('scroll', syncSticky, { passive: true });
      }
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }
  }

  /* Pre-checkout upgrade offer: single lamp -> The Hush Ritual.

     These PDPs skip the cart entirely — the buy button is a plain form POST to
     /cart/add carrying return_to=/checkout — so the only moment left to make
     the offer is the submit itself. This intercepts that submit for the single
     lamp tier and opens the dialog instead.

     Every other tier, and every state where the dialog did not render, falls
     through untouched: the handler returns early and Shopify's own form
     behaviour runs exactly as before. That is the safe default throughout —
     nothing here should ever be able to block a shopper from checking out. */
  /* --- One choice, one line item --------------------------------------
     The buy button is a plain POST to /cart/add carrying return_to=/checkout,
     and this store has no cart page — the cart is purely a staging area
     between the button and checkout. Backing out of checkout left the line
     item behind, so pressing buy again ADDED a second one and the shopper
     arrived holding two lamps.

     Detecting that return is unreliable: on a back navigation the browser
     reports the referrer the PDP originally had, not checkout, and the page is
     often restored from the bfcache with no script re-run at all. So the cart
     is emptied at the one moment that is always observable instead — the
     submit itself, immediately before the add. Whatever state the cart was
     left in, checkout is reached holding exactly the tier just chosen.

     This handler is registered before the upgrade offer's, so the clear
     happens first and the offer still gets its chance on the resubmit. If the
     clear fails the submit continues regardless: an extra line item is a far
     better outcome than a buy button that does nothing. */
  function cartReset() {
    var form = document.getElementById('hg-buy-form');
    if (!form) return;

    var clearing = false;
    var cleared = false;

    form.addEventListener('submit', function (event) {
      if (cleared || clearing) return;
      event.preventDefault();
      clearing = true;

      function resubmit() {
        cleared = true;
        clearing = false;
        /* Published so the upgrade offer can skip its own clear: the cart was
           just emptied and nothing has been added since, and a third cart API
           call inside the same second is what Shopify throttles. */
        window.hgCartCleared = true;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: '{}'
      }).then(resubmit, function () {
        window.hgCartCleared = false;
        resubmit();
      });
    });

    /* The flag only exists to let the resubmit through without looping. A page
       restored from the bfcache keeps it set, which would let the very journey
       this fixes — back out of checkout, buy again — skip the clear, so it is
       reset whenever the page is shown again. */
    window.addEventListener('pageshow', function () {
      cleared = false;
      clearing = false;
      window.hgCartCleared = false;
    });
  }

  function upsell() {
    var form = document.getElementById('hg-buy-form');
    var modal = document.querySelector('[data-hg-upsell]');
    if (!form || !modal) return;

    var ritualVariantId = modal.dataset.ritualVariantId;
    var dialog = modal.querySelector('.hg-upsell__dialog');
    var accept = modal.querySelector('[data-hg-upsell-accept]');
    var decline = modal.querySelector('[data-hg-upsell-decline]');
    var backdrop = modal.querySelector('[data-hg-upsell-backdrop]');
    var errorEl = modal.querySelector('[data-hg-upsell-error]');
    if (!ritualVariantId || !dialog || !accept || !decline) return;

    /* Set ONLY when the shopper explicitly declines, so the submit that
       immediately follows is allowed straight through.

       Closing on the backdrop or Escape deliberately does NOT set this. That
       is an undecided dismissal — they went back to the page rather than
       answering — so pressing the buy button again asks once more. Suppressing
       it there made the offer vanish for the rest of the visit after a stray
       tap outside the dialog, which is a worse failure than asking twice:
       declining takes them to checkout anyway, so there is no loop to get
       stuck in. */
    var declined = false;
    var lastFocused = null;

    /* Answering the offer settles it for the visit. Accepting or declining is
       a decision; backing out of checkout and choosing the single lamp again
       should not re-ask a shopper who has already said yes or no once. Held in
       sessionStorage because that return is a fresh page load, which would
       otherwise reset the in-memory flag. Storage can throw (private mode,
       blocked site data), and the offer simply reappears if it does — never a
       blocked checkout. */
    var answeredKey = 'hg-upsell-answered:' + (currentProduct() || 'pdp');

    function answered() {
      try {
        return window.sessionStorage.getItem(answeredKey) === '1';
      } catch (e) {
        return false;
      }
    }

    function markAnswered() {
      declined = true;
      try {
        window.sessionStorage.setItem(answeredKey, '1');
      } catch (e) {}
    }

    if (answered()) declined = true;

    function eligible() {
      var checked = form.querySelector('[data-hg-tier]:checked');
      return !!(checked && checked.dataset.hgUpsellSingle === 'true');
    }

    function report(name) {
      publishAnalytics(name, {
        current_product: currentProduct(),
        offered_bundle: 'the_hush_ritual',
        bundle_name: 'The Hush Ritual',
        section_name: 'purchase'
      });
    }

    function open() {
      lastFocused = document.activeElement;
      if (errorEl) errorEl.hidden = true;

      modal.hidden = false;
      document.body.classList.add('hg-upsell-open');
      /* Forces a style resolution between unhiding and the class that starts
         the transition. Without it the browser coalesces both into one pass
         and the dialog appears fully formed instead of fading in. */
      void modal.offsetWidth;
      modal.classList.add('is-open');

      accept.focus();
      report('checkout_upsell_shown');
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.classList.remove('hg-upsell-open');

      /* Kept in the layout until the fade finishes, or it would vanish
         instantly and the transition would never be seen. */
      if (reduceMotion) {
        modal.hidden = true;
      } else {
        window.setTimeout(function () {
          if (!modal.classList.contains('is-open')) modal.hidden = true;
        }, 280);
      }

      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function setBusy(busy) {
      accept.setAttribute('aria-busy', String(busy));
      accept.textContent = busy
        ? (accept.dataset.busyLabel || 'Adding…')
        : (accept.dataset.label || accept.textContent);
      decline.disabled = busy;
    }

    /* routes.* give the standard form paths (/cart/add); the Ajax API is the
       same path with a .js extension. Read from data attributes rather than
       written literally so localised market prefixes are preserved. */
    function ajaxUrl(value, fallbackPath) {
      var base = value || fallbackPath;
      return /\.js$/.test(base) ? base : base + '.js';
    }

    /* Shopify throttles rapid cart mutations from one session and answers 429.
       The offer fires its calls a second or two after the buy button already
       made one, so a single spaced-out retry turns the most likely failure
       into a hiccup the shopper never sees. Anything else fails fast — a wrong
       variant or a sold-out Ritual will not be fixed by asking twice. */
    function postJSON(url, body, retried) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body || {})
      }).then(function (response) {
        if (response.ok) return response;
        if (response.status === 429 && !retried) {
          return new Promise(function (resolve) {
            window.setTimeout(function () { resolve(postJSON(url, body, true)); }, 900);
          });
        }
        return response.text().then(function (text) {
          /* The dialog says only "try again"; the reason belongs in the
             console, where it can actually be diagnosed. */
          if (window.console) {
            console.warn('[hg] cart request failed', url, response.status, text);
          }
          throw new Error('Cart request failed: ' + response.status);
        });
      });
    }

    function upgrade() {
      setBusy(true);
      if (errorEl) errorEl.hidden = true;

      /* Replace rather than append. The shopper is swapping their choice, so
         leaving the single lamp behind would check them out with both it and
         the Ritual — which already contains that same lamp.

         Unless the buy button already emptied it on this very submit, in which
         case clearing again is a wasted call against a cart that is provably
         empty — and it was that extra call, landing in the same second as the
         other two, that Shopify's cart throttle answered with a 429. */
      var ready = window.hgCartCleared
        ? Promise.resolve()
        : postJSON(ajaxUrl(modal.dataset.cartClearUrl, '/cart/clear'));

      ready
        .then(function () {
          /* The add is a real form POST, not /cart/add.js.

             Choosing the Ritual from the tier list has always worked and has
             always been a plain form submit; this dialog was the only path
             using the Ajax add, and it was the only one failing. A navigation
             carries the session exactly as the buy button does and is not
             subject to whatever the Ajax endpoint objected to, so the offer
             now finishes through the same door as every other purchase.

             Safe to add without clearing here: the cart was emptied a moment
             ago, either by the buy button on this submit or by the call
             above. */
          var post = document.createElement('form');
          post.method = 'post';
          post.action = ajaxUrl(modal.dataset.cartAddUrl, '/cart/add').replace(/\.js$/, '');
          post.hidden = true;
          post.setAttribute('data-hg-upsell-post', '');

          function field(name, value) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            post.appendChild(input);
          }

          field('id', ritualVariantId);
          field('quantity', '1');
          field('return_to', modal.dataset.checkoutUrl || '/checkout');

          document.body.appendChild(post);
          post.submit();
        })
        .catch(function () {
          /* Deliberately no silent fallback that adds WITHOUT clearing: a
             half-completed swap would send them to checkout holding both
             items. Better to say so and let them retry, with declining still
             available. */
          setBusy(false);
          if (errorEl) errorEl.hidden = false;
        });
    }

    form.addEventListener('submit', function (event) {
      if (declined || !eligible()) return;
      event.preventDefault();
      open();
    });

    accept.addEventListener('click', function () {
      report('checkout_upsell_accepted');
      markAnswered();
      upgrade();
    });

    decline.addEventListener('click', function () {
      report('checkout_upsell_declined');
      markAnswered();
      close();
      /* Resume the original journey unchanged — single lamp, straight to
         checkout, exactly as pressing the buy button would have done. */
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });

    /* Accepting leaves the page mid-action: dialog open, "Adding your Ritual…"
       on the button, decline disabled. Backing out of checkout can restore the
       page from the back/forward cache exactly like that (seen in the
       Messenger in-app browser on iPhone, 01-11-2026), and with decline
       disabled the shopper is trapped. Reset on the way out so any snapshot is
       clean, and again on a restore in case the way-out reset didn't stick.
       `declined` is left alone: they answered, so the offer stays settled. */
    function resetForReturn() {
      setBusy(false);
      if (errorEl) errorEl.hidden = true;
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.classList.remove('hg-upsell-open');
      var leftovers = document.querySelectorAll('form[data-hg-upsell-post]');
      for (var i = 0; i < leftovers.length; i++) leftovers[i].remove();
    }
    window.addEventListener('pagehide', resetForReturn);
    window.addEventListener('pageshow', function (e) { if (e.persisted) resetForReturn(); });

    /* Backdrop and Escape only CLOSE — they never navigate. A stray tap
       outside the dialog should not send anyone to checkout; the labelled
       decline button is the only control that continues the purchase. */
    if (backdrop) backdrop.addEventListener('click', close);

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      /* Focus stays inside the dialog while it is open. */
      var focusables = dialog.querySelectorAll('button:not([disabled])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function bundleDisclosures() {
    document.querySelectorAll('[data-hg-bundle-disclosure]').forEach(function (disclosure) {
      var trigger = disclosure.querySelector('[data-hg-bundle-disclosure-trigger]');
      var panel = disclosure.querySelector('[data-hg-bundle-disclosure-panel]');
      if (!trigger || !panel) return;

      function setOpen(open) {
        trigger.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      }

      trigger.addEventListener('click', function () {
        /* Opening a card's details is an expression of interest in that offer,
           so select its radio too — otherwise only the top half of the Ritual
           card (its label) chose the bundle. Assigning .checked does not fire
           change on its own, so the event is dispatched for the price, CTA,
           stock badge and cart payload to resync. */
        var tier = trigger.closest('.hg-tier');
        var radio = tier && tier.querySelector('[data-hg-tier]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var open = trigger.getAttribute('aria-expanded') !== 'true';
        setOpen(open);
        // Only the complementary-product disclosure reports this event; the
        // "what's included" toggle shares the behaviour but not the meaning.
        if (open && disclosure.hasAttribute('data-hg-disclosure-analytics')) {
          publishAnalytics('bundle_product_explanation_opened', {
            current_product: currentProduct(),
            explained_product: currentProduct() === 'hush_ember' ? 'hush_halo' : 'hush_ember',
            bundle_name: 'The Hush Ritual',
            section_name: 'purchase'
          });
        }
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || trigger.getAttribute('aria-expanded') !== 'true') return;
        event.preventDefault();
        setOpen(false);
        trigger.focus();
      });
    });
  }

  /* --- 7. Timeline rail ------------------------------------------------
     Draws the connecting line as the list scrolls through the viewport by
     setting --draw (0-1). No scroll-jacking, no parallax: it only writes a
     custom property, and the CSS animates a height.                       */
  function timeline() {
    var list = document.querySelector('[data-hg-timeline]');
    if (!list) return;

    if (reduceMotion) { list.style.setProperty('--draw', '1'); return; }

    var ticking = false;
    function update() {
      var r = list.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // 0 when the list top reaches 85% of the viewport, 1 once its bottom
      // passes 40% — so the line finishes drawing before the section leaves.
      var start = vh * 0.85;
      var end = vh * 0.4;
      var p = (start - r.top) / Math.max(1, r.height - (start - end));
      list.style.setProperty('--draw', String(Math.min(1, Math.max(0, p))));
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* --- 8. Section reveal ----------------------------------------------
     One entrance per section, transform/opacity only, 300ms. Elements are
     revealed immediately if IntersectionObserver is unavailable, so nothing
     can end up permanently invisible.                                     */
  /* Hero feature disclosure. Mobile shows two pills; the rest live behind a
     "+N more features" control. Purely a class + aria toggle — the animation is
     a CSS grid 0fr/1fr transition, so nothing is measured here and the layout
     cannot jump. Above 768px the panel is always visible and the button is
     display:none, so a stale aria-expanded on desktop describes nothing. */
  function heroFeatures() {
    document.querySelectorAll('[data-hg-features-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('aria-controls');
      var panel = id ? document.getElementById(id) : null;
      if (!panel) return;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.classList.toggle('is-open', !open);
      });
    });
  }

  /* FAQ accordion — one answer open at a time, with an animated collapse.
     Native <details> can't animate: the browser stops rendering the content the
     instant `open` is removed, so there is nothing left to transition. The fix
     is to keep `open` on for the duration of the close and drive the visuals
     from an .is-open class instead, dropping `open` only once the transition
     has finished. .is-enhanced gates the CSS so a no-JS page keeps the native
     behaviour. */
  function faq() {
    document.querySelectorAll('[data-hg-faq]').forEach(function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.hg-faq__item'));
      if (!items.length) return;

      list.classList.add('is-enhanced');

      // Whatever the template rendered as open starts in the open state.
      items.forEach(function (item) {
        if (item.open) item.classList.add('is-open');
      });

      function close(item) {
        if (!item.open || !item.classList.contains('is-open')) return;

        item.classList.remove('is-open');

        if (reduceMotion) {
          item.open = false;
          return;
        }

        var panel = item.querySelector('.hg-faq__a');
        var settled = false;

        function done(e) {
          // Ignore bubbling transitions from the answer's own children.
          if (e && (e.target !== panel || e.propertyName !== 'grid-template-rows')) return;
          if (settled) return;
          settled = true;
          panel.removeEventListener('transitionend', done);
          clearTimeout(timer);
          // Re-opened mid-close? Then leave it open.
          if (!item.classList.contains('is-open')) item.open = false;
        }

        panel.addEventListener('transitionend', done);
        // transitionend never fires on a hidden tab or if the value doesn't
        // actually change, so the attribute would stick forever without this.
        var timer = setTimeout(done, 600);
      }

      function open(item) {
        item.open = true;               // content must be rendered first...
        if (reduceMotion) { item.classList.add('is-open'); return; }
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            item.classList.add('is-open');   // ...then animate 0fr -> 1fr
          });
        });
      }

      items.forEach(function (item) {
        var summary = item.querySelector('.hg-faq__q');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          // We own the open/close cycle; let the browser toggle and the
          // animation is skipped entirely.
          e.preventDefault();

          if (item.classList.contains('is-open')) {
            close(item);
            return;
          }

          items.forEach(function (other) { if (other !== item) close(other); });
          open(item);
        });
      });
    });
  }

  /* --- Product cross-sell analytics ---------------------------------- */
  function productCrossSellAnalytics() {
    var productKey = currentProduct();
    if (!productKey) return;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.hg-pdp-bridge a[href], .hg-final a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var selectedOffer = '';
      if (href.indexOf('/products/hush-ember') === 0) selectedOffer = 'hush_ember';
      if (href.indexOf('/products/hush-halo') === 0) selectedOffer = 'hush_halo';
      if (href.indexOf('hush-ritual') !== -1 || href.indexOf('hush-ritual-offer') !== -1) selectedOffer = 'the_hush_ritual';
      if (!selectedOffer || selectedOffer === productKey) return;

      publishAnalytics('cross_sell_product_clicked', {
        current_product: productKey,
        selected_offer: selectedOffer,
        section_name: link.closest('.hg-pdp-bridge') ? 'ritual_bridge' : 'final_cta'
      });
    });
  }

  /* --- Ritual landing-page analytics ---------------------------------
     Publish through Shopify's existing analytics bridge when available.
     The DOM event keeps interactions observable for QA and any first-party
     listener without adding a second analytics dependency. */
  function ritualPageAnalytics() {
    if (!document.body.classList.contains('hg-tpl-hush-ritual')) return;

    function sectionName(element) {
      if (element.closest('[data-hg-ritual-hero]')) return 'hero';
      if (element.closest('[data-hg-ritual-choice]')) return 'choice_guide';
      if (element.closest('.hg-ritual-offer')) return 'purchase';
      if (element.closest('.hg-final')) return 'final_cta';
      return 'ritual_page';
    }

    var viewTargets = document.querySelectorAll('[data-hg-ritual-choice], .hg-ritual-offer');
    if ('IntersectionObserver' in window) {
      var viewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          publishAnalytics('ritual_section_viewed', { section_name: sectionName(entry.target) });
          viewObserver.unobserve(entry.target);
        });
      }, { threshold: 0.3 });
      viewTargets.forEach(function (target) { viewObserver.observe(target); });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';

      if (href === '#hush-ritual-offer') {
        publishAnalytics('ritual_cta_clicked', {
          selected_offer: 'the_hush_ritual',
          bundle_name: 'The Hush Ritual',
          section_name: sectionName(link)
        });
        return;
      }

      if (href.indexOf('/products/hush-ember') === 0 || href.indexOf('/products/hush-halo') === 0) {
        publishAnalytics('single_product_selected', {
          selected_offer: href.indexOf('/products/hush-ember') === 0 ? 'hush_ember' : 'hush_halo',
          section_name: sectionName(link)
        });
      }
    });

    document.addEventListener('submit', function (event) {
      if (!event.target.matches('.hg-ritual-purchase__form')) return;
      publishAnalytics('ritual_cta_clicked', {
        selected_offer: 'the_hush_ritual',
        bundle_name: 'The Hush Ritual',
        section_name: 'purchase'
      });
    });
  }

  function reveal() {
    var targets = document.querySelectorAll('[data-hg-reveal]');
    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    targets.forEach(function (el) { el.classList.add('hg-reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (el) { io.observe(el); });
  }

  /* Shopify's cookie banner is injected into <body> asynchronously by its own
     privacy script, and removed outright once a choice is made. There is no
     event and no class to hook, so the only reliable signal is the element's
     presence in the DOM.

     The class exists so the sticky add-to-cart bar can get out of the way —
     both are fixed to the bottom of the viewport and would otherwise sit on
     top of each other on a PDP. See tokens.css, cookie-consent block. */
  /* Shopify's default disclosure runs to roughly 45 words, which is what made
     the banner tall on a phone more than any amount of padding did. The text
     is owned by Shopify's script, not the theme, so there is no setting for
     it — it has to be swapped in the DOM.

     The replacement still names every purpose the original does (experience,
     advertising, measurement) and keeps the promise that nothing is set
     without consent. The policy ANCHOR is moved, never rebuilt: Shopify sets
     its href per market and locale, and a hand-written /policies/... link
     would silently 404 in some regions. */
  var CONSENT_COPY = 'We use cookies for your experience, ads and analytics — only if you accept. Learn more in our ';

  function shortenConsentCopy(banner) {
    var body = banner.querySelector('.shopify-pc__banner__body');
    if (!body || body.dataset.hgShortened === 'true') return;

    var para = body.querySelector('p');
    var link = body.querySelector('#shopify-pc__banner__body-policy-link');
    if (!para || !link) return;

    para.textContent = CONSENT_COPY;
    para.appendChild(link);
    body.dataset.hgShortened = 'true';
  }

  function consentBanner() {
    var pending = false;

    /* Shopify mounts the prefs modal and leaves the banner sitting behind it.
       There is no state attribute to read, so visibility has to be measured.

       Two traps here, both of which silently return "closed" for a modal that
       is plainly on screen:
         - offsetParent is ALWAYS null for a position:fixed element, so it can
           never be used as a visibility test for a modal. getClientRects()
           is the check that actually works.
         - the id is not guaranteed to be exactly shopify-pc__prefs__dialog;
           Shopify has shipped the dialog under more than one id, so match on
           the shared prefix instead of betting on one spelling. */
    function prefsOpen() {
      var candidates = document.querySelectorAll('[id^="shopify-pc__prefs"]');

      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];

        /* Buttons inside the modal share the prefix; only the shell counts. */
        if (el.closest('#shopify-pc__banner')) continue;
        if (el.tagName === 'BUTTON' || el.tagName === 'A') continue;

        if (el.tagName === 'DIALOG' && typeof el.open === 'boolean') {
          if (el.open) return true;
          continue;
        }

        if (el.getClientRects().length > 0) return true;
      }

      return false;
    }

    function sync() {
      pending = false;
      var banner = document.querySelector('#shopify-pc__banner');
      document.body.classList.toggle('consent-banner-visible', !!banner && !prefsOpen());
      document.body.classList.toggle('consent-prefs-open', prefsOpen());
      if (banner) shortenConsentCopy(banner);
    }

    /* The observer watches the whole subtree, so it fires on unrelated DOM
       churn too (carousels, cart updates). Coalescing to one check per frame
       keeps that free rather than running a querySelector per mutation. */
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(sync);
    }

    sync();
    /* Attributes are watched as well as children: opening the prefs modal can
       flip nothing but its `open` attribute, which a childList-only observer
       would never see — the banner would then stay mounted underneath it. */
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'style', 'class', 'hidden']
    });

    /* Direct signal, so the swap happens on the same gesture rather than
       whenever Shopify's script next touches the DOM. Re-checked after a beat
       too, because the modal is not necessarily mounted by the time the click
       finishes bubbling. */
    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (!event.target.closest('[id^="shopify-pc__"]')) return;
      schedule();
      setTimeout(sync, 60);
      setTimeout(sync, 300);
    });
  }

  function init() {
    announcementBar();
    header();
    carousel();
    deferredImages();
    ugc();
    gallery();
    cartReset();
    bundles();
    upsell();
    bundleDisclosures();
    timeline();
    heroFeatures();
    faq();
    productCrossSellAnalytics();
    ritualPageAnalytics();
    consentBanner();
    reveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.HushGlow = { reduceMotion: reduceMotion };
})();
